/** System endpoints (public, no auth). */

import { apiFetch } from "./client";

export interface Health {
  status: string;
  db: string;
  valkey: string;
}

export const getHealth = (): Promise<Health> => apiFetch("/api/v1/system/health");
